"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.onRouteUpdate = exports.onClientEntry = void 0;

var _reactGa = _interopRequireDefault(require("react-ga"));

var _universalCookie = _interopRequireDefault(require("universal-cookie"));

var cookies = new _universalCookie["default"]();
var googleAnalyticsCookieName = 'gatsby-gdpr-google-analytics';
var facebookPixelCookieName = 'gatsby-gdpr-facebook-pixel';
var currentEnvironment = process.env.ENV || process.env.NODE_ENV || "development";
var defaultOptions = {
  environments: ['production'],
  googleAnalytics: {
    anonymize: true
  }
};

var isEnvironmentValid = function isEnvironmentValid(environments) {
  return environments.includes(currentEnvironment);
};

var onClientEntry = function onClientEntry(_, pluginOptions) {
  if (pluginOptions === void 0) {
    pluginOptions = {};
  }

  var options = Object.assign(defaultOptions, pluginOptions); // check for the correct environment

  if (isEnvironmentValid(options.environments)) {
    // - google analytics
    // check if the tracking cookie exists
    if (cookies.get(googleAnalyticsCookieName) === 'true') {
      // initialize google analytics with the correct ga tracking id
      _reactGa["default"].initialize(options.googleAnalytics.trackingId);
    } // - facebook pixel
    // check if the marketing cookie exists


    if (cookies.get(facebookPixelCookieName) === 'true' && typeof window.fbq === "function") {
      // initialize the facebook pixel stuff with the pixe id
      window.fbq('init', options.facebookPixel.pixelId);
    }
  }
};

exports.onClientEntry = onClientEntry;

var onRouteUpdate = function onRouteUpdate(_ref, pluginOptions) {
  var location = _ref.location;

  if (pluginOptions === void 0) {
    pluginOptions = {};
  }

  var options = Object.assign(defaultOptions, pluginOptions); // check for the production environment

  if (isEnvironmentValid(options.environments)) {
    // if the ga tracking cookie exists, track the page
    var gaAnonymize = options.googleAnalytics.anonymize;
    gaAnonymize = gaAnonymize !== undefined ? gaAnonymize : true; // check if the tracking cookie exists

    if (cookies.get(googleAnalyticsCookieName) === 'true') {
      _reactGa["default"].set({
        page: location.pathname,
        anonymizeIp: gaAnonymize
      });

      _reactGa["default"].pageview(location.pathname);
    } // if the fb pixel cookie exists, track the page


    if (cookies.get(facebookPixelCookieName) === 'true' && typeof window.fbq === "function") {
      window.fbq('track', 'PageView');
    }
  }
};

exports.onRouteUpdate = onRouteUpdate;